import { render, staticRenderFns } from "./InventoryMake.vue?vue&type=template&id=0a05b13b&scoped=true&"
import script from "./InventoryMake.vue?vue&type=script&lang=js&"
export * from "./InventoryMake.vue?vue&type=script&lang=js&"
import style0 from "./InventoryMake.vue?vue&type=style&index=0&id=0a05b13b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a05b13b",
  null
  
)

export default component.exports